var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialogComp',{ref:"dialog"},[_c('div',{staticClass:"tip"},[_c('div',{staticClass:"fail tip-box tip-box2"},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/fd6bea64ad9bd321654fd579a0df5eea.png","alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }